export default __webpack_public_path__ + "static/BoschSans-Bold-cde7664dded64f29c99d747998292da5.woff2";